import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';

/**
 * Tells the user what the camera is needed for before the browser asks for permission (BSI TR-03161-2 O.Plat_3).
 * The camera is only started after the user confirms with the button, so the browser's permission prompt is never
 * the first thing the user sees.
 */
@Component({
    selector: 'camera-purpose-notice',
    imports: [MatButtonModule, MatIconModule, TranslocoModule],
    templateUrl: './camera-purpose-notice.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class CameraPurposeNoticeComponent {
    /** What the camera is used for: a photo, or reading a QR code / barcode. */
    @Input() purpose: 'PHOTO' | 'CODE' = 'PHOTO';

    @Output() start = new EventEmitter<void>();
}
